/*
 * Public API Surface of Footer Component
 */

// MODULE
export * from './footer.module';

// COMPONENTS
export * from './components/footer/footer.component';

// MODELS
export * from './models/footer.model';
